<div class="scanner-overlay">
  <div class="scanner-actions">
    @if (torchSuportada) {
      <button mat-icon-button class="scanner-float-btn" type="button" (click)="alternarTorch()" [class.torch-on]="torchLigada" aria-label="Lanterna">
        <mat-icon>{{ torchLigada ? 'flashlight_on' : 'flashlight_off' }}</mat-icon>
      </button>
    }
    <button mat-icon-button class="scanner-float-btn" type="button" (click)="onFechar()" aria-label="Fechar leitor">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="scanner-viewport">
    <div [id]="readerId" class="scanner-reader"></div>

    @if (!erro) {
      <div class="scanner-guide" aria-hidden="true">
        <div class="scanner-hint">Escaneie o Código de Barras ou QR Code</div>
        <div class="scanner-frame">
          <span class="corner corner-tl"></span>
          <span class="corner corner-tr"></span>
          <span class="corner corner-bl"></span>
          <span class="corner corner-br"></span>
          <span class="scanner-scanline"></span>
        </div>
      </div>
    }

    @if (iniciando) {
      <div class="scanner-status">Iniciando câmera…</div>
    }

    @if (erro) {
      <div class="scanner-erro">
        <mat-icon>videocam_off</mat-icon>
        <p>{{ erro }}</p>
        <button mat-stroked-button type="button" (click)="onFechar()">Fechar</button>
      </div>
    }
  </div>
</div>
